import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        notesList: [],
        note: {},
        currentUser: {},
        currentUserRole: {}
    },
    getters: {
        currentUserRole: state => {
            return state.currentUserRole;
        }
    },
    mutations: {
        setCurrentUser (state, user) {
            state.currentUser = user;
        },
        setCurrentUserRole (state, user_role) {
            state.currentUserRole = user_role;
        }
    }
})
